export default __webpack_public_path__ + "static/media/ibbkidjaxxx-color.92d8bac5.svg";